import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { type ModalProps } from '@pkg/components';
import { Modal } from '@pkg/components/Modal';
import { WishlistThumbnail } from '@pkg/components/Wishlist/AddToWishlistModal/WishlistThumbnail';
import { useUpdateWishlist } from '@pkg/hooks';

import { type WishlistMetadataResponse } from '@app/client/resources/wishlists/types';

import { CreateWishlistContent } from '../AddToWishlistModal/CreateWishlist/CreateWishlistContent';
import { Heading, ModalLayout, SectionWrapper, Subheading } from '../AddToWishlistModal/CreateWishlist/styles';

export interface EditWishlistModalProps {
    onClose: ModalProps['onClose'];
    data: WishlistMetadataResponse;
}

export const EditWishlistModal = ({ onClose, data }: EditWishlistModalProps) => {
    const { t: translate } = useTranslation(['nft_details']);
    const [popoverFullyOpen, setPopoverFullyOpen] = useState(false);
    const [wishlistName, setWishlistName] = useState(data.name);
    const [isPrivate, setIsPrivate] = useState(data.private);
    const { mutateAsync: updateWishlist, isPending: isLoading } = useUpdateWishlist();

    const handleClose = () => {
        if (!popoverFullyOpen) onClose();
    };

    const handleUpdate = () => {
        if (data) {
            updateWishlist({ name: wishlistName, isPrivate, wishlist_id: data.id }).then(onClose);
        }
    };

    return (
        <Modal onClose={handleClose} mobileDarkBackground>
            <ModalLayout>
                <SectionWrapper>
                    <WishlistThumbnail slug={data.slug} />
                    <Heading>{translate('detail_view_wishlist_edit')}</Heading>
                    <Subheading>{translate('detail_view_wishlist_create_subheading')}</Subheading>
                </SectionWrapper>
                <CreateWishlistContent
                    isEdit
                    handleCreate={handleUpdate}
                    setPopoverFullyOpen={setPopoverFullyOpen}
                    setWishlistName={setWishlistName}
                    wishlistName={wishlistName}
                    setIsPrivate={setIsPrivate}
                    isPrivate={isPrivate}
                    isLoading={isLoading}
                />
            </ModalLayout>
        </Modal>
    );
};
